var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5v-4M8 6.5v-1M6.684 2.948c.569-1.04 2.063-1.04 2.632 0l4.42 8.082a1.5 1.5 0 01-1.315 2.22H3.579a1.5 1.5 0 01-1.316-2.22l4.421-8.082z",
    stroke: "#FF3461"
  })));
}
export default SvgIconWarning;